import { ReactNode } from 'react'
import s from './s.module.css'

function RequiredMark(label: ReactNode, { required }: { required: boolean }) {
  return (
    <>
      {label}
      {required && <span className={s.mark}>*</span>}
    </>
  )
}

export default RequiredMark
